import { Component, Input } from '@angular/core';
import { TravelItemMinimal } from '../../../api/models/travel-item-minimal';
import { CountryService } from '../../../api/services';
import { SlugifyPipe } from '../../pipes/slugify.pipe';
import { Router } from '@angular/router';
import { enumAssignmentStatus } from '../../utils/enum-assignment-request';
import { CountryItem } from '../../../api/models';

@Component({
  selector: 'app-travel-card-minimal',
  templateUrl: './travel-card-minimal.component.html',
  styleUrl: './travel-card-minimal.component.scss',
})
export class TravelCardMinimalComponent {
  @Input() travel!: TravelItemMinimal;
  @Input() country?: CountryItem;
  dates: string[] = [];
  enumAssignmentStatus = enumAssignmentStatus;
  cheapestPackagePrice?: number;

  constructor(
    private router: Router,
    private countryService: CountryService,
    private slugifyPipe: SlugifyPipe,
  ) {}

  ngOnInit() {
    if (this.travel.to_date && this.travel.from_date) {
      this.dates.push(this.travel.from_date);
      this.dates.push(this.travel.to_date);
    }
    //PRICE
    if (this.travel?.price_packages && this.travel?.price_packages.length > 0) {
      const prices = this.travel.price_packages.map((p) => p.price_per_person);
      this.cheapestPackagePrice = Math.min(...prices);
    }
  }

  goTo() {
    const slugifyName = this.slugifyPipe.transform(this.travel.name);
    this.router.navigate([
      '/viaggi-di-gruppo',
      this.travel.countries[0].country.ISO,
      this.travel.countries[0].country.name,
      this.travel.id,
      slugifyName,
    ]);
  }
}
